<template>
	<div class="portal-ad">
		<el-header class="userQueryHeader" height="32px">
			<div class="userQueryHeader-wrap"><span>个人数据中心配置</span></div>
		</el-header>
		<el-main>
			<sw-form class="form" :ref="form" :model="form" label-position="right" label-width="150px">
				<sw-form-item label="名称">
					<el-input v-model="form.name" :disabled="true"></el-input>
				</sw-form-item>
				<sw-form-item label="接口类型">
					<el-select v-model="form.type" placeholder="请选择接口类型" @change="changeOptions">
						<el-option v-for="item in options" :key="item.dataSourceValue"  :label="item.dataSourceName" :value="item.dataSourceValue"></el-option>
					</el-select>
				</sw-form-item>
				<sw-form-item v-for="(items, index) in otherFormList" :key="items.fieldName" :label="items.comment">
					<el-input v-model="items.value"></el-input>
				</sw-form-item>
				
				<sw-form-item class="btnBox">
					<el-button type="primary" @click="onSubmit(form)">立即创建</el-button>
					<el-button @click="cancle">取消</el-button>
				</sw-form-item>
			</sw-form>
		</el-main>
		
	</div>
</template>

<script>
	import { getOptions, getParams, getDetails, submitForm } from '@/api/personal.js'
	export default {
		name: 'detailEdit',
		data(){
			return {
				id: '',
				type: '',
				form: {
					name: '',
					type: ''
				},
				suffx: '',
				otherFormList: [
				// 	{
				// 	comment: '后缀',
				// 	suffix: ''
				// },
				],
				options: [],
				submitParam: {}
			}
		},
		created() {
			this.handleUrlInfo();
			this.handleDetails();
			this.handleOptionsList();
		},
		methods:{
			//获取链接后拼接参数
			handleUrlInfo() {
				let urlInfo = window.location.href;
				let urlParams = urlInfo.split('?');
				this.id = urlParams[1].split('=')[1];
				console.log(this.id);
			},
			// 请求option
			handleOptionsList(){
				let data = {
					id: this.id
				};
				getOptions(data).then((res) => {
					this.options = res.data.data;
				})
				
			},
			changeOptions(val){
				console.log(val)
				let data = {
					className: val
				}
				getParams(data).then((res) => {
					let list =res.data.data;
					list.forEach( item => {
						item.value = ''
					})
					
					this.otherFormList = list;
				})
			},
			handleDetails(){
				let data = {
					id: this.id
				};
				getDetails(data).then((res) => {
					this.form.name = res.data.list.name;
					this.form.type = res.data.list.dataSourceValue;
					this.otherFormList = res.data.list.params
				})
			},
			
			onSubmit(form){
				let params = {};
				this.otherFormList.forEach(item => {
					this.$set(this.submitParam, item.fieldName, item.value)
				})
				params =this.submitParam;
				// debugger
				// console.log(this.submitParam);
				// console.log(JSON.stringify(params));
				let data = {
					id: this.id,
					dataSourceValue: this.form.type,
					param: JSON.stringify(params)
				};
				submitForm(data).then((res) => {
					// console.log(res.data)
					if(res.code == 0){
						this.$message({
							message: "保存成功",
							type: "success",
						});
						this.$router.push({ name: "personalManage" });
					}else{
						this.$message.error(res.message);
					}
				})
			},
			cancle(){
				this.$router.go(-1);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.portal-ad {
		height: calc(100vh - 100px);
		margin-left: 50px;
		min-width: 1000px;
		.userQueryHeader {
			background: #f4f8fc;
			box-shadow: 0px -2px 3px rgba($color: #e7e7e7, $alpha: 0.5) inset;
			span {
				font-size: 12px;
				line-height: 32px;
				padding: 0 2px;
			}
			&-wrap {
				span {
					padding-left: 7px;
					border-left: 3px solid #3394e1;
					color: rgba(2, 21, 37, 0.45);
				}
			}
		}
		.form{
			// display: flex;
			// flex-wrap: wrap;
			.el-select,
			.el-input,
			.el-textarea {
				width: 800px;
			}
			.btnBox{
				width: 100%;
				display: flex;
				justify-content: center;
			}
		}
	}
</style>